import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineEpromConfigurationLabel";

const url = "/api/machines/MachineEpromConfigurationLabel";

export const machineEpromConfigurationLabel = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "EPROM Label",
    url,
    additionalColumns: [
      ColumnDefinitionServiceName,
      (columnDefinitionService: ColumnDefinitionService) => {
        return [
          columnDefinitionService.getBooleanColDef({
            field: "ExcludeFromEpromAuditReport",
            header: "Exclude From EPROM Audit Report",
          }),
          columnDefinitionService.getBooleanColDef({
            field: "IsProgressiveSoftware",
            header: "Progressive Software in Eprom Report",
          }),
        ];
      },
    ],
    additionalFields: [
      () => [
        fieldHelpers.simpleBoolField({
          key: "ExcludeFromEpromAuditReport",
          label: "Exclude From EPROM Audit Report",
          defaultValue: false,
        }),
        fieldHelpers.simpleBoolField({
          key: "IsProgressiveSoftware",
          label: "Progressive Software in Eprom Report",
          defaultValue: false,
        }),
      ],
    ],
  }
);
